export const TYPES = {
  SET_BAILIFF_JOB_ALL: "bailiff_job/SET_BAILIFF_JOB_ALL",
  SET_BAILIFF_JOB_OPEN_ADD: "bailiff_job/SET_BAILIFF_JOB_OPEN_ADD",
  SET_BAILIFF_JOB_OPEN_EDIT: "bailiff_job/SET_BAILIFF_JOB_OPEN_EDIT",
  SET_BAILIFF_JOB_OPEN_PAYMENT: "bailiff_job/SET_BAILIFF_JOB_OPEN_PAYMENT",
  SET_BAILIFF_JOB_SELECTED: "bailiff_job/SET_BAILIFF_JOB_SELECTED",
  SET_BAILIFF_JOB_SEARCH: "bailiff_job/SET_BAILIFF_JOB_SEARCH",
  //
  SET_BAILIFF_JOB_DETAIL: "bailiff_job/SET_BAILIFF_JOB_DETAIL",
  SET_BAILIFF_JOB_BANKS: "bailiff_job/SET_BAILIFF_JOB_BANKS",
  //
  SET_BAILIFF_JOB_PREVIEW: "bailiff_job/SET_BAILIFF_JOB_PREVIEW",
  SET_BAILIFF_JOB_EXTRACTING_COUNT:
    "bailiff_job/SET_BAILIFF_JOB_EXTRACTING_COUNT",
};
